import { useState, useEffect, useCallback } from 'react';
import { apiCall } from '../utils/api';

export function useEmailSync() {
  const [syncStatus, setSyncStatus] = useState(null);
  const [newEmails, setNewEmails] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);
  const [error, setError] = useState(null);

  const syncEmails = useCallback(async () => {
    if (isSyncing) return; // Prevent duplicate syncs

    setIsSyncing(true);
    setError(null);

    try {
      const data = await apiCall('/api/email/sync-strategy', {
        method: 'POST',
      });

      if (data.success) {
        setSyncStatus(`Imported ${data.imported} new emails`);
        setNewEmails(data.subjects || []);
      } else {
        setError(data.error || 'Sync failed');
        setSyncStatus(`Error: ${data.error}`);
      }
    } catch (err) {
      console.error('Email sync error:', err);
      // Don't block the user; email sync is optional
      setError('Could not sync emails (continuing anyway)');
      setSyncStatus('Could not sync emails (continuing anyway)');
    } finally {
      setIsSyncing(false);
    }
  }, [isSyncing]);

  // Clear status after 10 seconds
  useEffect(() => {
    if (syncStatus) {
      const timer = setTimeout(() => {
        setSyncStatus(null);
        setNewEmails([]);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [syncStatus]);

  return {
    syncStatus,
    newEmails,
    isSyncing,
    error,
    syncEmails,
  };
}
